import { merge } from 'lodash';
import { CSSProperties } from 'react';
import { IBlockData, RecursivePartial } from '@core/typings';
import { BasicType, AdvancedType, DynamicType } from '@core/constants';
import { createCustomBlock, t } from '@core/utils';
import { Image } from '../Image';

export type IDynamicImage = IBlockData<
	{
		alt?: string;
		src?: string;
		title?: string;
		href?: string;
		target?: string;
		border?: string;
		height?: string;
		'text-decoration'?: string;
		'text-transform'?: CSSProperties['textTransform'];
		align?: CSSProperties['textAlign'];
		'container-background-color'?: string;
		width?: string;
		padding?: string;
		'border-width'?: string;
		'border-style'?: string;
		'border-color'?: string;
	},
	{
		imageType?: 'static' | 'dynamic';
		dynamicImageTag?: string;
		dynamicImageId?: string;
	}
>;

export const DynamicImageBlock = createCustomBlock<IDynamicImage>({
	get name() {
		return t('Image');
	},
	type: DynamicType.IMAGE,
	create: (payload?: RecursivePartial<IDynamicImage>) => {
		const defaultData: IDynamicImage = {
			type: DynamicType.IMAGE,
			data: {
				value: {
					imageType: 'dynamic',
					dynamicImageTag: '',
				},
			},
			attributes: {
				align: 'center',
				height: 'auto',
				padding: '0px 0px 0px 0px',
				src: '',
				width: '',
				border: '',
				'border-width': '',
				'border-style': '',
				'border-color': '',
				'container-background-color': 'transparent',
			},
			children: [],
		};
		return merge(defaultData, payload);
	},
	validParentType: [
		BasicType.COLUMN,
		BasicType.HERO,
		AdvancedType.COLUMN,
		AdvancedType.HERO,
	],
	render(params) {
		// Delegate rendering to the standard Image block — dynamic image tag
		// resolution lives there.
		return Image.render(params as any);
	},
});
